<template>
  <div class="modal" @keydown.esc="$emit('close')">
    <div class="modal-content">
      <form @submit.prevent="saveLocation">
        <div class="modal-header">
          <h1>Edit location</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" @click="$emit('close')"
                  aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <label for="code" class="form-label
            ">Code</label>
            <input type="text" class="form-control" id="code" v-model="locationData.code" ref="inputCode" required>
          </div>
          <div class="mb-3">
            <label for="name" class="form-label">Name</label>
            <input type="text" class="form-control" id="name" v-model="locationData.name" required>
          </div>
          <div class="mb-3">
            <label for="site_id" class="form-label">Site</label>
            <select class="form-select" id="site_id" v-model="locationData.site_id" required>
              <option v-for="site in sites" :key="site.id" :value="site.id">{{ site.name }}</option>
            </select>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="$emit('close')">Cancel
          </button>
          <button type="submit" class="btn btn-primary">Save</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import {useSiteStore} from '@/store/siteStore';
export default {
  name: 'EditLocationModal',
  props: {
    location: {
      type: Object,
      required: true,
    },
    organisationSlug: {
      type: String,
      required: true,
    }
  },
  mounted() {
    this.$refs.inputCode.focus();
    this.loadSites();
    this.locationData.site_id = this.location.site.id; // Set the current site ID
  },
  data() {
    return {
      locationData: {},
    };
  },
  computed: {
    sites() {
      const siteStore = useSiteStore();
      return siteStore.sites;
    }
  },
  watch: {
    location: {
      immediate: true,
      handler(newVal) {
        this.locationData = {...newVal};
      },
    },
  },
  methods: {
    async loadSites() {
      const siteStore = useSiteStore();
      await siteStore.fetchSites(this.organisationSlug);
    },
    async saveLocation() {
      this.$emit('save-location', this.locationData);
    },
  },
};
</script>

<style scoped>
.modal {
  display: block;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);
}

.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
}

.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}
</style>